var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"design-preview",attrs:{"aria-hidden":"true"}},[_vm._m(0),_c('i',{staticClass:"dp-cards"},_vm._l((3),function(card){return _c('b',{key:card,staticClass:"dp-card"})}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"dp-cover"},[_c('b',{staticClass:"dp-title"}),_c('b',{staticClass:"dp-chips"})])
}]

export { render, staticRenderFns }